// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__RoSGU","avatar":"FeatureCard_avatar__cEBkO","button":"FeatureCard_button__RK6aI"};